export default "__VITE_ASSET__BGsQMbwA__"